import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import BufferTabView from 'buffers/BufferTabView';
import {REQUESTS_V2_ANALYTICS_ACTIONS} from 'constants/analytics-products/RequestsV2AnalyticsConstants';
import {ActionMethod, ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import RequestV2SubmissionProgressAndOutputs from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputs';
import RequestV2SubmissionProgressAndOutputsTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class RequestV2SubmissionProgressAndOutputsTabView extends BufferTabView<RequestV2SubmissionProgressAndOutputsTabState> {
  render(): this {
    const requestV2SubmissionFileState = this.model.getRequestV2SubmissionFileState();
    const props = {
      requestV2SubmissionId: requestV2SubmissionFileState.id,
      folder: requestV2SubmissionFileState.model().folder(),
    };
    analytics.trackEvent(REQUESTS_V2_ANALYTICS_ACTIONS.CLICKED_REQUEST_V2_PROGRESS_AND_OUTPUTS_TAB, {
      request_v2_submission_id: props.requestV2SubmissionId,
      action_origin: ActionOrigin.REQUEST_V2_SUBMISSION,
      action_method: ActionMethod.BUTTON_CLICK,
    });
    renderToDOM(
      <div className="react-tab-container" style={{padding: 0}}>
        <RequestV2SubmissionProgressAndOutputs {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<RequestV2SubmissionProgressAndOutputsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestV2SubmissionProgressAndOutputsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
